import { Cookie } from '@vue-util/cookie';
import logger from '@vue-util/logger';
import { useEnvPropsStore } from '@/stores/useEnvPropsStore';

function redirect(url) {
  window.location.href = url;
}
function relativeRedirect(relativePath) {
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split(currentUrl);
  const path = urlParts[0] + relativePath + urlParts[1];
  logger.info(`[PPE] SESSION_TIMEOUT DETECTED, redirecting to ${path} from ${currentUrl}`);
  redirect(path);
}
export function handleSessionTimeout(errorCode, redirectPath = '/account/signin') {
  if (
    errorCode === '02011' ||
    errorCode === '40420' ||
    errorCode === '40401' ||
    errorCode === '02016' ||
    errorCode === '02012' ||
    errorCode === '80020' ||
    errorCode === '80067'
  ) {
    const envPropsStore = useEnvPropsStore();
    const domain = envPropsStore.envProps.cookieDomain;
    if (errorCode === '40420') {
      // delete the cookie to prevent log in page from redirecting
      // back to order history page
      Cookie.remove('X-Macys-UID');
    }
    Cookie.remove('SignedIn', null, {
      domain,
    });
    Cookie.set('SE', 1, 'SNSGCs', {
      domain,
    });
    Cookie.set('FORWARDPAGE_KEY', window.location.href, null, {
      domain,
    });
    relativeRedirect(redirectPath);
  }
  return false;
}
